import React from "react";
import styles from "./InstanceLayout.module.scss";
import RippleLayout from "../../../../../components/ripple/RippleLayout";

function InstanceLayout({title, id, custom, onClick, disabled, children}) {

    return (
        <div className={styles.layout} id={id}>
            <RippleLayout
                className={styles.layout__container}
                onClick={onClick}
                disabled={disabled}
                visuals={{animationDuration: '400ms', opacityHover: ['0.2']}}
            >
                    <div className={styles.layout__container__title}>{title}</div>
                    <div className={styles.layout__container__content}>{children}</div>
            </RippleLayout>
        </div>
    )
}

export default InstanceLayout